import { Component, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/_services/utility.service';
import Swal from 'sweetalert2';
//import { Title } from 'chart.js/dist';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-bacheca',
  templateUrl: './bacheca.component.html',
  styleUrls: ['./bacheca.component.css']
})
export class BachecaComponent implements OnInit {
  // sidenavClosed$ = this.sidebarService.getSidenavClosed();
  // isSidenavClosed: boolean;
  bacheca: any;
  notification: any;

  pagina: string = 'Bacheca';
  isMobile: boolean = false;
  isTablet: boolean = false;
  numberSlice: number;

  constructor(
    private titleService: UtilityService,
    private title: Title
  ) {}

  ngOnInit() {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 567) {
      this.isMobile = true;
      this.isTablet = false;
      this.numberSlice = 50;
    } else if (screenWidth >= 567 && screenWidth <= 900) {
      this.isTablet = true;
      this.isMobile = false;
      this.numberSlice = 70;
    } else {
      this.isTablet = false;
      this.isMobile = false;
      this.numberSlice = 90;
    }

    this.title.setTitle('Bacheca | Sviluppo Personale');
    this.titleService.setTitle('Bacheca');
  }

  icons = ['star', 'hotel_class', 'auto_awesome'];

  difficulties = [
    { value: 1, icon: this.icons[0] },
    { value: 2, icon: this.icons[1] },
    { value: 3, icon: this.icons[2] }
  ];

  readOnly: boolean = true;

  getIconStyle(value: string) {
    if (value === 'Alta') {
      return { 'border-color': '#E53935' };
    } else if (value === 'Media') {
      return { 'border-color': '#FFAB00' };
    } else {
      return { 'border-color': '#43A047' };
    }
  }

  isNotificationsEmpty(): boolean {
    return !this.notification || this.notification.length === 0;
  }
  openDescription(description: any) {
    Swal.fire({
      title: 'Descrizione completa',
      text: description,
      confirmButtonColor: '#00337C'
    });
  }
}
